import InspectionType from "./actionTypes"

const INIT_STATE = {
  order: {
    loading: true,
    data: []
  },
  rtwOrder: {
    loading: true,
    data: []
  },
  detailOrder: {
    loading: true,
    data: []
  },
  detailRtwOrder: {
    loading: true,
    data: []
  },
  postOrder: {
    loading: false,
    data: []
  },
  postRtwOrder: {
    loading: false,
    data: []
  },
  patchDefect: {
    loading: false,
    data: []
  },
  orderSize: {
    loading: true,
    data: {}
  },
  rtwOrderSize: {
    loading: true,
    data: {}
  },
  postMemo: {
    loading: false
  }
}

const Inspection = (state = INIT_STATE, action) => {
  switch (action.type) {
    case InspectionType.GET_INSPECTION_ORDER_LIST_SUCCESS:
      return {
        ...state,
        order: action.payload,
      }

    case InspectionType.GET_INSPECTION_RTW_ORDER_LIST_SUCCESS:
      return {
        ...state,
        rtwOrder: action.payload,
      }

    case InspectionType.GET_INSPECTION_DETAIL_ORDER_SUCCESS:
      return {
        ...state,
        detailOrder: action.payload,
      }

    case InspectionType.GET_INSPECTION_DETAIL_RTW_ORDER_SUCCESS:
      return {
        ...state,
        detailRtwOrder: action.payload,
      }

    case InspectionType.GET_INSPECTION_DETAIL_ORDER_SIZE_SUCCESS:
      return {
        ...state,
        orderSize: action.payload,
      }

    case InspectionType.GET_INSPECTION_DETAIL_RTW_ORDER_SIZE_SUCCESS:
      return {
        ...state,
        rtwOrderSize: action.payload,
      }

    case InspectionType.POST_ORDER_SUCCESS:
      return {
        ...state,
        postOrder: action.payload,
      }
    case InspectionType.POST_RTW_ORDER_SUCCESS:
      return {
        ...state,
        postRtwOrder: action.payload,
      }
    case InspectionType.PATCH_DEFECT_SUCCESS:
      return {
        ...state,
        patchDefect: action.payload,
      }
    case InspectionType.POST_ORDER_MEMO_SUCCESS:
    case InspectionType.POST_RTW_ORDER_MEMO_SUCCESS:
      return {
        ...state,
        postMemo: action.payload,
      }

    default:
      return state
  }
}

export default Inspection
